export default "__VITE_PUBLIC_ASSET__c7a414e2__"